import { base64ToArrayBuffer } from './base64ToArrayBuffer';

export const downloadFile = ({ data, name, type }) => {
  const blob = new Blob([base64ToArrayBuffer(data)], { type });
  const link = window.document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = name; // remove this to open in a new browser
  link.click();
};
